module.exports = __webpack_public_path__ + "img/1508985896.39201a5f.jpg";